module.exports = __webpack_public_path__ + "img/imgSrc11.1a83347d.png";